module.exports = __webpack_public_path__ + "static/media/Alliance of Merger and Acquisition Advisors Logo.54940c92.jpeg";